export default __webpack_public_path__ + "static/media/010-naughty.7bfe0460.svg";